import { componentName, ButtonSelectionGroupItemClass } from './ButtonSelectionGroupItemClass';
import '@descope-ui/descope-button';

customElements.define(componentName, ButtonSelectionGroupItemClass);

export { ButtonSelectionGroupItemClass };
